import React, { useState } from "react";
import { UserRound } from "lucide-react";
import { Student } from "@/types/Student";

export const StudentImage = ({ student }: { student: Partial<Student> }) => {
  const [loadingError, setLoadingError] = useState(false);
  const { imageUrl, studentOrganizationStatus } = student;
  const { name } = studentOrganizationStatus || {};

  if (!imageUrl?.url || loadingError) {
    return (
      <div className="h-full w-full bg-background-light object-cover p-7">
        <UserRound className="h-full w-full text-icon-light" />
      </div>
    );
  }

  const onError = () => {
    setLoadingError(true);
  };

  return (
    <img
      src={imageUrl?.url ?? undefined}
      onError={onError}
      alt={`${name}`}
      className="h-full w-full object-cover"
    />
  );
};
